// @flow
import { deleteCreator, getCreator, postCreator, putCreator } from '../../../http';
import environment from '../../../environment';

import type { Country } from '../../../entities';

export type AddressRequest = {
  address1: string;
  address2?: ?string;
  admin1: number;
  admin2: number;
  admin3?: number;
  country: Country;
  firstName?: string;
  idNumber?: string;
  lastName?: string;
  name?: string;
  phone?: string;
  zipCode?: ?string;
};

export const endpoints = Object.freeze({
  SEARCH_ADMIN1: `${environment.apiUrl}/geography/location/:country`,
  SEARCH_ADMIN2: `${environment.apiUrl}/geography/location/:country/:admin1`,
  SEARCH_ADMIN3: `${environment.apiUrl}/geography/location/:country/:admin1/:admin2`,
  FETCH_ADDRESSES: `${environment.apiUrl}/preferences/address`,
  POST_ADDRESS: `${environment.apiUrl}/preferences/address`,
  PUT_ADDRESS: `${environment.apiUrl}/preferences/address/:id`,
  DELETE_ADDRESS: `${environment.apiUrl}/preferences/address/:id`,
});

export const searchAdmin1Api = getCreator(fetch, endpoints.SEARCH_ADMIN1);
export const searchAdmin2Api = getCreator(fetch, endpoints.SEARCH_ADMIN2);
export const searchAdmin3Api = getCreator(fetch, endpoints.SEARCH_ADMIN3);
export const getAddressesApi = getCreator(fetch, endpoints.FETCH_ADDRESSES);
export const postAddressApi = postCreator(fetch, endpoints.POST_ADDRESS);
export const putAddressApi = putCreator(fetch, endpoints.PUT_ADDRESS);
export const deleteAddressApi = deleteCreator(fetch, endpoints.DELETE_ADDRESS);



// WEBPACK FOOTER //
// ./src/modules/preferences/saved-addresses/api.js